<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";
import CheckList3 from "../checkList3.vue";
import Maintenance from "../Maintenance.vue";
import Print from "./print";
import lingprint from "../lingprint.vue";
import logo from "../../../assets/logo.png";
import { IMAGE_HOST } from "@/../config";
import checkDeskShow from "../../../views/device/checkDeskShow.vue";
import editRelatesInfo from "./editRelatesInfo.vue";
import config from "../../../../config";
export default {
  extends: baseList,
  components: {
    baseList,
    Print,
    lingprint,
    checkDeskShow,
    editRelatesInfo,
  },
  data() {
    return {
      table: {
        mname: "consumablesreceive",
        key: "id",
        url: {
          del: "/admin/system/receive",
        },
        output: false,
        order: "receiveTime",
      },
      actions: [
        {
          label: "导出数据",
          type: "info",
          icon: "md-download",
          // onClick: this.exportData.bind(this, "领用列表", 2),
          // auth: "system/consumablesrecord/exportData",
          onClick: this.exportdata,
        },
      ],
      menus: [],
      filters: [
        {
          label: "领用时间",
          KeyEnter: this.search,
          name: "receiveTime",
          value: "",
          type: "datetimerange",
        },
        {
          label: "核算科室",
          KeyEnter: this.search,
          name: "checkDeskId",
          value: "",
          type: "select",
          dropList: [],
        },
        {
          label: "领用科室",
          name: "deskId",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },

        {
          label: "物资单号",
          name: "id",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "派送人",
          name: "maintainerName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      exportdata: "",
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "物资单号",
          width: 100,
          key: "id",
          align: "center",
        },
        {
          title: "领用类型",
          width: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.receiveType == 2 ? "目录外申请" : "目录内物资";
            return <span>{text}</span>;
          },
        },
        {
          title: "核算科室",
          key: "checkDeskName",
          minWidth: 140,
          align: "left",
          tooltip: "true",
          render: (h, params) => {
            const row = params.row;
            const text = row.checkDeskName ? row.checkDeskName : "";
            const list = this.checkListArr;
            return (
              <checkDeskShow
                text={text}
                item={row}
                type={2}
                list={list}
                onReset={() => {
                  this.search();
                }}
              />
            );
          },
        },
        {
          title: "申请人",
          width: 180,
          align: "left",
          render: (h, p) => {
            let html = [];
            html.push(
              <div style="float:center">
                <span>{p.row.desk} </span>
                <span>{p.row.receive} </span>
              </div>
            );
            return <div>{html}</div>;
          },
        },
        {
          title: "申请内容",
          minWidth: 250,
          key: "sysConsumableReceiveDetail",
          render: (h, params) => {
            return (
              <div>
                {params.row.sysConsumableReceiveDetail.map((item) => {
                  return (
                    <div>
                      {item.brand ? item.brand + "/" : ""}
                      {item.inventoryName}/{item.model}*{item.alterNum}
                      {item.unit}
                    </div>
                  );
                })}
              </div>
            );
          },
        },
        {
          title: "关联信息",
          width: 150,
          align: "left",
          key: "sysConsumableFacilityList",
          render: (h, params) => {
            const row = params.row.sysConsumableFacilityList;
            const state = params.row.state;
            return (
              <div>
                {state == 3 || state == 5 ? (
                  <div
                    onClick={() => this.RelatesInfo(params.row)}
                    style="cursor: pointer;"
                  >
                    {row.length > 0 ? (
                      row.map((item) => (
                        <div style=" width: 100%; height: 20px;background-color: transparent; cursor: pointer;">
                          {item.facilityNo}
                        </div>
                      ))
                    ) : (
                      <div style=" width: 100px; height: 50px;background-color: transparent; cursor: pointer;"></div>
                    )}
                  </div>
                ) : null}
              </div>
            );
          },
        },
        {
          title: "签收图片",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.nameUrl;
            return (
              <div>
                <el-image
                  style="width: 3.125rem;"
                  fit="contain"
                  src={text == "" || text == null ? logo : IMAGE_HOST + text}
                  preview-src-list={[
                    text == "" || text == null ? logo : IMAGE_HOST + text,
                  ]}
                >
                  {" "}
                  <div slot="error" class="image-slot">
                    <img style="width:3.125rem;height:3.125rem;" src={logo} />
                  </div>
                </el-image>
              </div>
            );
          },
        },
        {
          title: "审核人",
          width: 100,
          align: "center",
          key: "approveName",
          render: (h, params) => {
            const row = params.row;
            const text = row.approveName;
            return <span>{text}</span>;
          },
        },
        {
          title: "派送人",
          width: 100,
          align: "center",
          key: "maintainerName",
        },
        // {
        //   title: '数量',
        //   minWidth: 80,
        //   align: 'center',
        //   key: 'receiveNum',
        // },
        {
          title: "状态",
          width: 100,
          key: "state",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state === 1
                ? "已申请"
                : row.state === 2
                ? "派送中"
                : row.state === 3
                ? "已完成"
                : row.state === 4
                ? "审核中"
                : row.state === 5
                ? "已收货"
                : row.state === 6
                ? "已拒绝"
                : "";
            return <span style={{ "font-size": ".875rem" }}>{text}</span>;
          },
        },
        // {
        //   title: "完成时间",
        //   width: 150,
        //   align: "center",
        //   key: "finishTime",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.finishTime ? row.finishTime.slice(0, 16) : null;
        //     return <span>{text}</span>;
        //   },
        // },
        {
          title: "操作",
          align: "center",
          width: 240,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.handleEdit(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: ".3125rem",
                  }}
                >
                  详情
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.toPrint(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: ".3125rem",
                  }}
                >
                  打印
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let state = param.row.state;
              return (
                <Button
                  v-show={state == 1 ? true : false}
                  size="small"
                  onClick={() => this.tozhuandan(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: ".3125rem",
                  }}
                >
                  转单
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let obj = param.row.sysConsumableReceivePurchaseResponse;
              let receiveType = param.row.receiveType;
              return (
                <Button
                  size="small"
                  v-show={obj != null && receiveType == 2 ? true : false}
                  onClick={() => this.toPrint1(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    margin: ".3125rem 0",
                  }}
                >
                  打印采购单
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let obj = param.row.sysConsumableReceivePurchaseResponse;
              let state = param.row.state;
              let receiveType = param.row.receiveType;
              return (
                <Button
                  v-show={
                    state == 1 && receiveType == 2 && obj == null ? true : false
                  }
                  size="small"
                  onClick={() => this.toCheck1(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: ".3125rem",
                  }}
                >
                  发起采购
                </Button>
              );
            },
            "delete",
          ],
          // auth: {
          //   del: "/admin/comment/del",
          // },
        },
      ],
      IMAGE_HOST: IMAGE_HOST,
      checkListArr: [],
    };
  },
  created() {
    let query = this.$route.query;
    if (query.inventoryId) {
      this.query.inventoryId = query.inventoryId;
    }
    this.checkData();
    this.deskListMethod();
    this.getCheckDeskList();
  },
  methods: {
    handleSelect(selected) {
      let arry = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        arry.push(element[this.table.key]);
      }
      this.selected = arry.join(",");
      this.exportdata = arry.join(",");
    },
    async exportdata() {
      if (this.exportdata == [] || this.exportdata.length == 0) {
        $utils.toast.warn("请选择需要导出数据");
        return;
      } else {
        let q = {};
        // q.order = this.order;
        q.query = this.query;
        let qq = this.query || {};
        for (const key in qq) {
          if (Object.hasOwnProperty.call(qq, key)) {
            const element = qq[key];
            if (element) {
              q[key] = element;
            }
          }
        }
        q.ids = this.exportdata;
        this.$Message.info("数据正在导出，请稍后");
        $utils.api
          .load(`/admin/system/receive/export`, q, "GET")
          .then((res) => {
            if (res) {
              this.urldata = res.msg;
              window.location.href =
                config.API_HOST +
                `/admin/common/download?fileName=${this.urldata}`;
            }
          })
          .catch((err) => {
            $utils.loading.hide();
          });
      }
    },
    checkData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/check/listNoChild", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.checkDeskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "checkDeskId") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    RelatesInfo(row) {
      this.$Modal.success({
        closable: true,
        title: "修改关联信息",
        width: "1000px",
        height: "5rem",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return <editRelatesInfo Id={row.id}></editRelatesInfo>;
        },
      });
    },
    toPrint(row) {
      this.$Modal.success({
        closable: true,
        title: "物资领用 送货/签收单",
        width: "62.5rem",
        height: "5rem",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return <Print workId={row.id}></Print>;
        },
      });
    },
    toPrint1(row) {
      this.$Modal.success({
        closable: true,
        title: "物资领用 采购单",
        width: "62.5rem",
        height: "5rem",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return <lingprint workId={row.id}></lingprint>;
        },
      });
    },
    //单个采购
    toCheck1(row) {
      this.$Modal.remove();
      setTimeout(() => {
        this.$Modal.success({
          closable: true,
          title: "采购",
          okText: "取消",
          width: "75rem",
          showOk: false,
          render: (h) => {
            return (
              <CheckList3
                style={{ margin: "0", color: "#19be6b" }}
                id={row.id}
              ></CheckList3>
            );
          },
        });
      }, 300);
    },
    tozhuandan(row) {
      this.$Modal.remove();
      setTimeout(() => {
        this.$Modal.success({
          closable: true,
          title: "转单",
          okText: "取消",
          width: "31.25rem",
          showOk: false,
          render: (h) => {
            return (
              <Maintenance
                style={{ margin: "0", color: "#19be6b" }}
                id={row.id}
              ></Maintenance>
            );
          },
        });
      }, 300);
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/desk/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "deskId") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    async deskListMethod() {
      let res = await $utils.api.load("/admin/system/desk/selectList");
      let deskList = res.rows;
      for (let i = 0; i < deskList.length; i++) {
        let workInfotemp = "";
        if (
          deskList[i].deskName !== null &&
          deskList[i].deskName !== undefined
        ) {
          workInfotemp = deskList[i].deskName;
        }
        if (
          deskList[i].principal !== null &&
          deskList[i].principal !== undefined
        ) {
          workInfotemp = workInfotemp + "/" + deskList[i].principal;
        }
        if (deskList[i].phone !== null && deskList[i].phone !== undefined) {
          workInfotemp = workInfotemp + "/" + deskList[i].phone;
        }
        if (deskList[i].address !== null && deskList[i].address !== "") {
          workInfotemp = workInfotemp + "/" + deskList[i].address;
        }
        deskList[i].deskName = workInfotemp;
      }
      let dropList = [];
      for (let index = 0; index < deskList.length; index++) {
        const element = deskList[index];
        let xx = {};
        xx.value = element.id;
        xx.name = element.deskName;
        xx.children = element.children || [];
        dropList.push(xx);
      }
      for (let index = 0; index < this.filters.length; index++) {
        const element = this.filters[index];
        if (element && element.name == "deskId") {
          this.filters[index]["dropList"] = (element["dropList"] || []).concat(
            dropList
          );
        }
      }
    },
    async getCheckDeskList() {
      let d = {};
      let res = await $utils.api.load("admin/system/check/list", d, "get");
      if (res.code == 200) {
        let data = res.rows;
        let dropList = [];
        if (data && data.length > 0) {
          dropList = data.map((item) => ({
            value: item.id,
            label: item.checkDeskName,
            disabled: !item.children || item.children.length === 0,
            children: (item.children || []).map((child) => ({
              value: child.id,
              label: child.checkDeskName,
            })),
          }));
        }
        this.checkListArr = dropList;
      }
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "recordInfo",
        query: { action: "edit", kv: currentRow.id },
      });
    },
  },
};
</script>
<style scoped>
.RelatesInfo {
  width: 0.625rem;
  height: 1.25rem;
  background-color: aqua;
}
</style>
